// Auto-generated by scripts/generateFactionSkinConfig.mjs
// Do not edit manually.

// eslint-disable-next-line no-unused-vars
import {FACTIONS} from '../../../constants/factions';
// eslint-disable-next-line no-unused-vars
import {PLAYER_COLORS} from '../../colors';

export const FACTION_SKINS_UNDEAD = [{
  id: 'undead_sceleton',
  factionId: FACTIONS.UNDEAD,
  name: 'Скелет-центурион',
  priceNumens: 13000,
  skinRank: 1,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.ORANGE
  ]
}, {
  id: 'undead_ghost',
  factionId: FACTIONS.UNDEAD,
  name: 'Потусторонний ужас',
  priceNumens: 38000,
  skinRank: 2,
  colors: [
    PLAYER_COLORS.CELADON,
    PLAYER_COLORS.SKY_BLUE,
    PLAYER_COLORS.BLUE,
  ]
}, {
  id: 'undead_vampire',
  factionId: FACTIONS.UNDEAD,
  name: 'Жаждущий крови',
  priceNumens: 75000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.RED,
  ]
}, {
  id: 'undead_death',
  factionId: FACTIONS.UNDEAD,
  name: 'Смерть',
  priceNumens: 90000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.BLUE,
    PLAYER_COLORS.CELADON,
  ]
}, {
  id: 'undead_gold_legacy',
  factionId: FACTIONS.UNDEAD,
  name: 'Жрец погоста',
  priceNumens: 90000,
  skinRank: 3,
  colors: [
    PLAYER_COLORS.YELLOW,
  ],
  excludedFromChests: true
}, {
  id: 'undead_ruby_legacy',
  factionId: FACTIONS.UNDEAD,
  name: 'Король-лич',
  priceCrystals: 200,
  skinRank: 4,
  colors: [
    PLAYER_COLORS.LIGHT_GREEN,
    PLAYER_COLORS.RED,
  ],
  accentColor: PLAYER_COLORS.RED,
  excludedFromChests: true
}];
